module.exports = __webpack_public_path__ + "static/dribble-782c31b2a79180c51c6c537a1ae28136.png";